import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DropDownFuncionario } from "../../../../../../common/components/dropdown_funcionario";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";

// Header 

// Header 

type Props = {
  funcionarios: FuncionarioDropDown[],
  tipoPesquisa: number,
  pesquisa: string | Date | number | null,
  onClearFilters: () => void;
  handleTipoPesquisa: (v: number) => void,
  handlePesquisa: (v: string | number | null) => void,
};

export const Header = ({
  funcionarios, 
  tipoPesquisa, 
  pesquisa, 
  handlePesquisa, 
  handleTipoPesquisa, 
  onClearFilters 
}: Props) => {
  const handleFuncionarioSelect = useCallback((newFuncionario: FuncionarioDropDown | null) => {
    handlePesquisa(newFuncionario?.idFuncionario ?? null);
  }, [handlePesquisa]);
  
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-3 grid-cols-1 md:grid-cols-[275px,1fr,220px]">
          <div className="flex gap-1">
            <FormControl size="small" sx={{ width: "275px" }}>
              <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
              <Select
                size="small"
                labelId="modulo-dashboard"
                label="Pesquisar por"
                value={tipoPesquisa}
                onChange={(event: SelectChangeEvent<number>) => {
                  handlePesquisa(null); 
                  handleTipoPesquisa(event.target.value as number)
                }}>
                <MenuItem value={0}>Processo</MenuItem>
                <MenuItem value={1}>Responsável</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="w-full">
            {(tipoPesquisa === 0 ) ? (
              <DefaultInput
                label="Pesquisar"
                name="search_by_name"
                value={typeof pesquisa === 'string' ? pesquisa : ''}
                onChangeValue={handlePesquisa}
              />
            ): (tipoPesquisa === 1) ? (
              <DefaultAutocomplete
                options={funcionarios}
                getOptionLabel={x => x.nome}
                getOptionKey={x => x.idFuncionario}
                label="Funcionário"
                value={funcionarios.find(x => x.idFuncionario === pesquisa) || null}
                onChange={handleFuncionarioSelect}
                onNew={() => { }} 
              />
            ): <></>}
          </div>

          {/* Botão Limpar */}
          <div className="w-full flex justify-end md:col-span-3">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}